// extracted by mini-css-extract-plugin
export default {"checkbox":"elMH4L","checkboxError":"C13BBx"};